/*
  ** NotFound.jsx **
  Redireciona para a página de erro
*/
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

function NotFound() {
  const history = useHistory();

  useEffect(() => {
    history.push("/");
  }, []);
  return null;
}

export default NotFound;
